export const getAppointmentPhoneNumber = (
  appointmentPatientPhoneNumber: string | null,
  patientPhoneNumber: string | null,
) => {
  return appointmentPatientPhoneNumber || patientPhoneNumber || null
}
